import { httpClient } from "../utilities/HttpHelper"
import { apiHost } from "../constants/api"
import { emptyAreaResponse } from "../constants/response"

export const getAreaMaster = async (province, amphoe, tambon) => {
    let q = []
    if(province!==null&&(typeof province!=='undefined')) q.push(`province=${province}`)
    if(amphoe!==null&&(typeof amphoe!=='undefined')) q.push(`amphoe=${amphoe}`)
    if(tambon!==null&&(typeof tambon!=='undefined')) q.push(`tambon=${tambon}`)
    let fetchUrl = `${apiHost}/area?${q.join("&")}`
    let response = await httpClient.get(fetchUrl)
    if(response.status === 200) {
        return response.data
    }
    return []
}

export const getAreaCurrent = async (province, amphoe, tambon) => {
    let q = []
    // console.log('getAreaCurrent')
    if(province!==null&&(typeof province!=='undefined')) q.push(`province=${province}`)
    if(amphoe!==null&&(typeof amphoe!=='undefined')) q.push(`amphoe=${amphoe}`)
    if(tambon!==null&&(typeof tambon!=='undefined')) q.push(`tambon=${tambon}`)
    let fetchUrl = `${apiHost}/area/current?${q.join("&")}`
    let response = await httpClient.get(fetchUrl)
    if(response.status === 200) {
        return response.data
    }
    return []
}

export const getAreaHistory = async (type, tambon, amphoe, province) => {
    let fetchUrl;
    if(type==='daily') {
        fetchUrl = `${apiHost}/area/history?tambon=${tambon}&amphoe=${amphoe}&province=${province}&days=30`
    } else if (type==='weekly') {
        fetchUrl = `${apiHost}/area/history/weekly?tambon=${tambon}&amphoe=${amphoe}&province=${province}&days=210`
    } else if (type==='monthly') {
        fetchUrl = `${apiHost}/area/history/monthly?tambon=${tambon}&amphoe=${amphoe}&province=${province}&days=620`
    } else if (type==='yearly') {
        fetchUrl = `${apiHost}/area/history/yearly?tambon=${tambon}&amphoe=${amphoe}&province=${province}&days=3650`
    }
    // console.log('getAreaHistory url: ', fetchUrl)
    let response = await httpClient.get(fetchUrl)
    if(response.status === 200) {
        // console.log('getAreaHistory response: ', response.data)
        if(response.data !== null) {
            return response.data
        } else {
            return emptyAreaResponse
        }
    }
    return []
}